import { createContext } from "react";
var StyleMatchContext = /*#__PURE__*/createContext({
  loading: false,
  step: 'silhouette',
  currentSelection: [],
  currentUrl: '',
  fashionUrl: 'https://www.theknot.com'
  // "https://qa-fashion-api.engagement.xogrp.com/api/dresses/query_count?scopes=wedding_gown"
});

export default StyleMatchContext;